import moment from 'moment';
import R from 'ramda';

// ISODate :: String
// @link: https://en.wikipedia.org/wiki/ISO_8601

// YYYY-MM-DDThh:mm:ss.sssZ :: "2017-08-16T19:49:50.940Z"
// YYYY-MM-DD               :: "2017-08-16"

// diff :: String -> ISODate|String -> ISODate|String -> Number
const diff = (whatToDiff, firstDate, secondDate) =>
  moment(firstDate).diff(moment(secondDate), whatToDiff);

export default R.curryN(2, diff);
